/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {  TGetGeoTagsRequest,  TGetGeoTagsModel,  IMappers,  TGetGeoTagsResponse } from './types'
import type {  IHttpApi,  IHttpApiFetchConfig,  FetchResponse } from '@cian/http-api'
import type {  IV1GeoTagsResponse } from '../../entities/get_geo_tags/V1GeoTagsResponse'
import type {  IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema'


export function createGetGeoTagsModel(parameters: TGetGeoTagsRequest): TGetGeoTagsModel {
return {
v: 1,apiType: 'public',method: 'POST',microserviceName: 'geo-temp-layer',pathApi: '/v1/get-geo-tags/',response: {
200: {
contentType: 'json',
},400: {
contentType: 'json',
},
},request: {
contentType: 'json',parameters,

},
};
}


export interface IGetGeoTagsOptions<TResponse200, TResponse400>  {
httpApi: IHttpApi;
config?: IHttpApiFetchConfig;
mappers?: IMappers<TResponse200, TResponse400>;
parameters: TGetGeoTagsRequest;

}

export async function fetchGetGeoTags<TResponse200, TResponse400>({
httpApi,
config,
mappers,
parameters,

}: IGetGeoTagsOptions<TResponse200, TResponse400>): Promise<FetchResponse<TGetGeoTagsResponse> | TResponse200 | TResponse400> {
const {
statusCode,
response,
headers,

} = (await httpApi.fetch(createGetGeoTagsModel(parameters), config)) as FetchResponse<TGetGeoTagsResponse>;
if (mappers && statusCode in mappers) {
if (statusCode === 200) {
return mappers[200](response as IV1GeoTagsResponse, headers);
}if (statusCode === 400) {
return mappers[400](response as IErrorResponseSchema, headers);
}
}return {
statusCode,
response,
headers,

} as FetchResponse<TGetGeoTagsResponse>;
}

